'use strict';

import { base, io, Component, PropTypes, stores, update, sub, fromJS, toJS, mq } from 'core';

import { Button, ButtonToolbar, ListGroup, ListGroupItem, Grid, Row, Col, Input, Panel, Modal } from 'react-bootstrap';

import { Paper, Dialog } from 'material-ui';

import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';

import { debug_ui, google_key } from 'config';

import $style from './style.styl';

@base({
    track: [[]]
})
class Toast extends Component {

    render() {

        return (
            <span></span>
        );
    }
}

io.on('overlay:location', function(data) {

    const { app: { get, edit } } = stores();

    edit('global', 'overlay', {
        open: true,
        body: <iframe src={`https://www.google.com/maps/embed/v1/place?q=${data}&key=${google_key}`}
                      width="100%" height="100%" frameBorder="0" allowFullScreen />
    });
});
@base({
    track: [['global', 'overlay']]
})
class GlobalOverlay extends Component {

 	render() {

        const { get, edit } = this._atom();

        const { open, body } = get() || {};

        const display = open === true ? 'block' : 'none';

        return (
            <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          transition: 'all 0.6s ease', zIndex: 10000,
                          position: 'fixed', width: '100%', height: '100%',
                          bottom: 0, left: 0, right: 0, top: 0, display }}
                 onTouchTap={() => edit({ open: false })}>
                <Paper style={{ width: '75%', height: '70%', margin: '10% auto 0' }}>
                    {body}
                </Paper>
            </div>
        );
	}
};

@base({
    track: [['global', 'backdrop']]
})
class GlobalBackdrop extends Component {

 	render() {

        const { get, edit } = this._atom();

        const display = get('open') === true ? 'block' : 'none';

        return (
            <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          transition: 'all 0.6s ease', zIndex: 10000,
                          position: 'fixed', width: '100%', height: '100%',
                          bottom: 0, left: 0, right: 0, top: 0, display }} />
        );
	}
};

@base({
    track: [[]]
})
class GlobalAlert extends Component {

 	render() {

        const { get, edit } = this._atom();

        const alertHeader = get('title')
            && (
                <Modal.Header closeButton>
                    <Modal.Title>
                        { get('title') }
                    </Modal.Title>
                </Modal.Header>
            );

        const alertBody = get('body')
            && (
                <Modal.Body>
                    { get('body') }
                </Modal.Body>
            );

        const alertFooter = get('footer')
            && (
                <Modal.Footer>
                    footer
                </Modal.Footer>
            );

        return (
            <Modal show={ get('open') } onHide={ _=> edit('open', false) }>
                { alertHeader }
                { alertBody }
                { alertFooter }
            </Modal>
        );
	}
};

@base({
    track: []
})
class GlobalDialog extends Component {

    componentWillUpdate() {

        this._get('open') && this.refs.dialog.show();
    }
 	render() {

        const { get, edit } = this._atom();

        const { title, description, media, cancel, submit, onSubmit, actions = true } = toJS(get() || {});

        let Actions = [
            { text: cancel || 'Cancelar' },
            { text: submit || 'Ok', onTouchTap: onSubmit || (() => {}) }
        ];

        return (
            <Dialog title={ title } ref="dialog" onDismiss={() => edit('open', false)} actions={ Actions }>
                <div style={{ float: 'left', width: '50%', paddingRight: 15 }}>
                    { media && <img src={ media } style={{ maxWidth: '100%' }} /> }
                </div>
                <div style={{ float: 'right', width: '50%' }}>
                    { description }
                </div>
            </Dialog>
        );
	}
};

@base({
    track: []
})
class GlobalGalery extends Component {

    styles = {
        wrapper: {
            position: 'fixed', width: '100%', height: '100%', bottom: 0, left: 0, zIndex: 100000
        },

        closeIcon: {
            position: 'fixed', left: 12, top: 10, zIndex: 11, cursor: 'pointer',
            fontWeight: '900', fontSize: 24, fontFamily: 'sans-serif'
        },

        backdrop: {
            position: 'fixed', width: '100%', height: '100%', bottom: 0, left: 0,
            background: 'rgba(255, 255, 255, 0.95)', zIndex: 10
        },

        card: {
            WebkitTapHighlightColor: 'rgba(0,0,0,0)',
            //boxShadow: '0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22)',
            borderRadius: 2,
            //backgroundColor: '#ffffff',
            //backgroundImage: `url('http://res.cloudinary.com/accede/image/upload/o_35/v1452692209/old_office/curvasbg.png')`,
            backgroundPosition: '0% 50%',
            backgroundSize: 'cover',
            position: 'relative',
            width: '75%',
            maxWidth: 980,
            margin: '0px auto',
            padding: '20px 16px',
            top: '12%',
            overflow: 'hidden',
            zIndex: 100000
        },

        carousel: {
            wrapper: {
                width: '100%',
                overflow: 'hidden',
                height: 100
            },

            inner: {
                position: 'absolute',
                whiteSpace: 'nowrap',
                transition: 'all 0.6s ease-out'
            },

            pic: {
                height: 100, width: 120, display: 'inline-block',
                backgroundSize: 'cover', boxShadow: '0 0 10px -2px #999',
                borderRadius: 2, marginRight: 16
            },

            video_thumb: {
                position: 'absolute',
                right: '25%',
                top: '33%',
                fontSize: 34,
                color: '#BBB'
            }
        }
    }

    not_selected_index = ':0'

    reset = () => (
        this.setState({
            current: this.not_selected_index
        })
    );

    componentWillMount() {

        this.reset();
    }

 	render() {

        const { current = this.not_selected_index } = (this.state || {});

        const { get, edit } = this._atom();

        const { title, description, fullDescription, media,
                open, cancel, submit, onSubmit, images: all_images = [], videos = [] } = toJS(get() || {});

        const locale = this._store().get('locale') || 'Pt';

        const images = all_images.filter(img => img['media' + locale]);

        const media_length = images.length + videos.length;

        const media_index = current.split(':').pop() || 0;

        const media_type = ((current == this.not_selected_index || current.match(/^p:.*/)) && videos.length <= 0)
            ? 'picture' : 'video';

        const media_element = (media_length > 0) && (
            (media_type == 'picture')
            ? ( <img src={ (images && images[media_index]) ? images[media_index]['media' + locale] : media }
                     style={{ maxWidth: '100%', maxHeight: '100%' }} /> )
            : ( <iframe
                    width="100%" height="300" frameBorder="0" allowFullScreen
                    src={`https://www.youtube.com/embed/${videos[media_index].media}`} /> ));

        const description_element = (((current == this.not_selected_index || current.match(/^v:.*/))
                ? fullDescription : (images[media_index].description || fullDescription)) ||'')
                                                        .replace(/http:\/\/\//g, '/');

        const list_index = parseInt(media_index) + parseInt( media_type == 'video' ? 0 : videos.length );

        const left = -(((list_index - 1 > 0 ? list_index - 1 : 0) * 116) - 16);

        const video_key = (i) => `v:${i}`;
        const pic_key = (i) => `p:${i}`;

        const video = (pic, i) =>
            <div onTouchTap={() => this.setState({ current: video_key(i) })}
                 className="galery-carousel-thumb"
                 key={video_key(i)} style={{ ...this.styles.carousel.pic,
                                  background: '#eee',
                                  transform: `scale(${current == video_key(i) ? 1.2 : 1})` }}>
                <i className="icon-play3" style={ this.styles.carousel.video_thumb } />
            </div>;

        const picture = (pic, i) =>
            <div onTouchTap={() => this.setState({ current: pic_key(i) })}
                 className="galery-carousel-thumb"
                 key={pic_key(i)}
                 style={{ ...this.styles.carousel.pic,
                          backgroundSize: 'cover',
                          backgroundPosition: '50% 30%',
                          backgroundImage: `url('${pic['media'+locale]}')`,
                          transform: `scale(${current == pic_key(i) ? 1.2 : 1})` }} />;

        const carousel = () =>
            <div style={ this.styles.carousel.wrapper }>
                <div style={{ ...this.styles.carousel.inner, left }}>
                    {[
                        ...videos.map(video),
                        ...images.map(picture)
                     ]}
                </div>
            </div>;

        const media_wrapper = () => (media_length > 0)
         && <div style={{ float: 'left',
                          height: 'calc(100% - 41px)' }}>
                { media_element }
            </div>;

        const description_wrapper = () => (description_element) && (
            <div dangerouslySetInnerHTML={{ __html: description_element }}
                 style={{
                     float: 'left',
                     width: (media_length > 0) ? '95%' : '95%',
                     fontSize: 16,
                     lineHeight: '25px',
                     position: 'absolute',
                     bottom: 25,
                     textAlign: 'left'
                 }}
            />
        );

        const carousel_wrapper = () => (media_length > 1) && (
            <div
                style={{
                    ...this.styles.card,
                    position: 'fixed',
                    width: '100%',
                    maxWidth: 'none',
                    left: 0,
                    bottom: 0,
                    top: 'initial'
                }}
                className="galery-carousel">
                { carousel() }
            </div>
        );

        return (
            <VelocityComponent animation={open? 'fadeIn' : 'fadeOut'} duration={300}>
                <div style={ this.styles.wrapper }>
                    <div
                        style={{
                            ...this.styles.card,
                            maxHeight: '64%',
                            height: '100%'
                        }}
                        className="galery-card" ref="card"
                        onTouchTap={() => { console.log('card touch') }}>

                        <div style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
                            <div style={{ padding: '0 0 15px', display: 'block' }}>
                                <h3 dangerouslySetInnerHTML={{ __html: title }}/>
                            </div>

                            { media_wrapper() }
                            { description_wrapper() }
                            <div className="clearfix"/>
                        </div>
                    </div>

                    { carousel_wrapper() }

                    <div style={ this.styles.closeIcon } onTouchTap={() => (this.reset(), edit('open', false))}>X</div>
                    <div style={ this.styles.backdrop } onTouchTap={() => (this.reset(), edit('open', false))}/>
                </div>
            </VelocityComponent>
        );
	}
};

@base({
    styles: [ $style ],
    track: false
})
class Footer extends Component {

    constructor(props) {

        super(props);

        this.ns = {
            alert: ['global', 'alert'],
            dialog: ['global', 'dialog'],
            galery: ['global', 'galery'],
            backdrop: ['global', 'backdrop'],
            overlay: ['global', 'overlay']
        }
    }

    footer_text = {
        'Pt': 'Accede - Automação Industrial - Rua 24 de Fevereiro, 47 - Jardim Olavo Bilac - São Bernardo do Campo, SP - CEP 09725-820 - (11) 4398-7300 | (11) 4398-7114',
        'En': 'Accede - Automação Industrial - Rua 24 de Fevereiro, 47 - Jardim Olavo Bilac - São Bernardo do Campo, SP - CEP 09725-820 - +55 (11) 4398-7300 | +55 (11) 4398-7114'
    }

 	render() {

        const { get, edit } = this.props;

        const locale = this._store().get('locale') || 'Pt';

  		return (
            <div className="footer">

                <div className="internal_footer">
                    <span style={{ textAlign: 'center', display: 'inline-block', width: '100%',
                                   fontWeight: 'bold', textShadow: '0 0 1px white', color: '#222' }}>

                    </span>
                </div>

                <div className="footer-helpers">
                    <GlobalAlert  {...this._sub(...this.ns.alert)} />
                    <GlobalDialog {...this._sub(...this.ns.dialog)} />
                    <GlobalGalery {...this._sub(...this.ns.galery)} />
                    <GlobalBackdrop {...this._sub(...this.ns.backdrop)} />
                    <GlobalOverlay {...this._sub(...this.ns.overlay)} />
                </div>
            </div>
  		);
	}
};

export default Footer



// WEBPACK FOOTER //
// ./ui/c/footer/index.jsx